import { render } from "./HeroSpotlight.vue?vue&type=template&id=4f35f447&scoped=true"
import script from "./HeroSpotlight.vue?vue&type=script&lang=js"
export * from "./HeroSpotlight.vue?vue&type=script&lang=js"

import "./HeroSpotlight.vue?vue&type=style&index=0&id=4f35f447&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f35f447"]])

export default __exports__